<template>
  <div class="app-container">
    <!-- begin app-main -->
    <div class="app-main" id="main">
      <!-- begin container-fluid -->
      <div class="container-fluid">
        <!-- begin row -->
        <div class="row">
          <div class="col-md-12 m-b-30">
            <!-- begin page title -->
            <div class="d-block d-sm-flex flex-nowrap align-items-center">
              <div class="page-title mb-2 mb-sm-0">
                <h1>Riders</h1>
              </div>
              <div class="ml-auto d-flex align-items-center">
                <nav>
                  <ol class="breadcrumb p-0 m-b-0">
                    <li class="breadcrumb-item">
                      <a >
                        <i class="ti ti-home"></i>
                      </a>
                    </li>
                    <li class="breadcrumb-item">Riders</li>
                  </ol>
                </nav>
              </div>
            </div>
            <!-- end page title -->
          </div>
        </div>
        <!-- Modal -->
        <div
          class="modal fade"
          id="createModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="createModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Create Rider</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label>First Name</label>
                    <input type="text" class="form-control" v-model="editRider.first_name" />
                  </div>
                  <div class="form-group">
                    <label>Last Name</label>
                    <input type="text" class="form-control" v-model="editRider.last_name" />
                  </div>
                  <div class="form-group">
                    <label>Email</label>
                    <input type="email" class="form-control" v-model="editRider.email" />
                  </div>
                  <div class="form-group">
                    <label>Phone Number</label>
                    <input type="text" class="form-control" v-model="editRider.phone_number" />
                  </div>
                  <div class="form-group">
                    <label>Password</label>
                    <input type="password" class="form-control" v-model="editRider.password" />
                    <small class="form-text text-muted">Password need to be atleast 8 characters</small>
                  </div>
                  <div class="form-group">
                    <label>Confirm Password</label>
                    <input
                      type="password"
                      class="form-control"
                      v-model="editRider.password_confirmation"
                    />
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button
                  v-if="validated"
                  type="button"
                  @click="createRider();"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >Create Rider</button>
              </div>
            </div>
          </div>
        </div>
        <!-- begin row -->
        <div class="row">
          <div class="col-lg-12">
            <Loader v-if="$store.getters.isLoading" />
            <div v-else class="card card-statistics">
              <div class="card-body">
                <Loader v-if="$store.getters.isLoading" />
                <div v-else class="export-table-wrapper table-responsive">
                  <div class="export-buttons m-b-20 row">
                    <a
                      href="#"
                      id="exportExcel"
                      class="btn btn-primary col-2"
                      data-toggle="modal"
                      data-target="#createModal"
                    >Create Riders</a>
                    <div class="col-1"></div>
                  </div>
                  <table id="export-table" class="table table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone Number</th>

                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <span v-if="riders.length < 1">No Rider Found</span>
                      <tr v-for="(rider,index) in riders" :key="index">
                        <td>{{rider.user.first_name | capitalize }} {{ rider.user.last_name | capitalize }}</td>
                        <td>{{rider.user.email}}</td>
                        <td>{{rider.user.phone_number}}</td>
                        <td>
                          <button
                            class="btn btn-danger"
                            @click.prevent="deleterider(rider.id,index)"
                          >🗑</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <sliding-pagination
                    v-if="riders.length > 0"
                    :current="currentPage"
                    :total="totalPages"
                    @page-change="pageChangeHandler"
                  ></sliding-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container-fluid -->
    </div>
    <!-- end app-main -->
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Loader from "../../components/Loader.vue";
export default {
  data() {
    return {
      riders: [],
      states: [],
      keyword: "",
      editing: false,
      state: "all",
      currentPage: 1,
      totalPages: 1,
      editRider: {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        password: "",
        password_confirmation: ""
      }
    };
  },
  components: {
    Loader
  },
  mounted() {
    this.getriders();
  },
  methods: {
    pageChangeHandler(page) {
      this.currentPage = page;
      if (this.keyword.length < 1) this.getriders();
      else this.querySearch();
    },
    getriders() {
      this.$store.commit("setLoading", true);
      fetch(
        this.$store.getters.baseURL + "riders/all?page=" + this.currentPage,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          }
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.riders = result.data.data;
            this.currentPage = result.data.current_page;
            this.totalPages = result.data.last_page;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    deleterider(id, index) {
      const link = this.$store.getters.baseURL + "riders/" + id + "/destroy";

      Swal.queue([
        {
          icon: "warning",
          title: "Delete rider?",
          confirmButtonText: "Confirm Delete!",
          showCancelButton: true,
          text: "This action is irreversible and can break the system",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            return fetch(link, {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.$store.getters.getToken
              }
            })
              .then(response => response.json())
              .then(result => {
                if (result.status) {
                  Swal.insertQueueStep({
                    icon: "success",
                    title: result.message
                  });
                  this.riders.splice(index, 1);
                } else {
                  Swal.insertQueueStep({
                    icon: "error",
                    title: result.message
                  });
                }
              })
              .catch(() => {
                Swal.insertQueueStep({
                  icon: "error",
                  title: "Some thing went wrong",
                  text: "Check your internet connection"
                });
              });
          }
        }
      ]);
    },

    createRider() {
      this.$store.commit("setLoading", true);
      fetch(this.$store.getters.baseURL + "riders/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.getToken
        },
        body: JSON.stringify(this.editRider)
      })
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.riders = [result.data, ...this.riders];
            Swal.fire({
              icon: "success",
              title: result.message
            });
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    }
  },
  computed: {
    validated() {
      if (this.editRider.first_name.length < 1) return false;
      if (this.editRider.last_name.length < 1) return false;
      if (this.editRider.email.length < 1) return false;
      if (this.editRider.phone_number.length < 11) return false;
      if (this.editRider.password.length < 8) return false;
      if (this.editRider.password != this.editRider.password_confirmation)
        return false;
      return true;
    }
  }
};
</script>

<style scoped></style>
